export const SUPPORT_CENTER_WEEKDAYS = [
  { label: 'Dom', value: 0 },
  { label: 'Seg', value: 1 },
  { label: 'Ter', value: 2 },
  { label: 'Qua', value: 3 },
  { label: 'Qui', value: 4 },
  { label: 'Sex', value: 5 },
  { label: 'Sáb', value: 6 },
] as const

export const SUPPORT_CENTER_MONTHS = [
  { label: 'Janeiro', value: 1 },
  { label: 'Fevereiro', value: 2 },
  { label: 'Março', value: 3 },
  { label: 'Abril', value: 4 },
  { label: 'Maio', value: 5 },
  { label: 'Junho', value: 6 },
  { label: 'Julho', value: 7 },
  { label: 'Agosto', value: 8 },
  { label: 'Setembro', value: 9 },
  { label: 'Outubro', value: 10 },
  { label: 'Novembro', value: 11 },
  { label: 'Dezembro', value: 12 },
] as const

export function daysInMonth(year: number, month: number): number {
  return new Date(year, month, 0).getDate()
}

export function buildIsoDate(year: number, month: number, day: number): string {
  const y = String(year).padStart(4, '0')
  const m = String(month).padStart(2, '0')
  const d = String(day).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function parseIsoDate(iso: string): { year: number; month: number; day: number } {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number)
  return { year: y, month: m, day: d }
}

export function formatWeekdaysSummary(weekdays: number[]): string {
  if (!weekdays.length) return '—'
  const dayLabels = SUPPORT_CENTER_WEEKDAYS.filter((d) => weekdays.includes(d.value)).map(
    (d) => d.label
  )
  return dayLabels.length ? dayLabels.join(', ') : '—'
}

export function formatHoursSummary(hours: number[]): string {
  if (!hours.length) return '—'
  return [...hours]
    .sort((a, b) => a - b)
    .map((h) => `${h.toString().padStart(2, '0')}h`)
    .join(', ')
}

export function formatDateBr(isoDate: string): string {
  const { year, month, day } = parseIsoDate(isoDate)
  return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`
}

export function toggleSortedNumber(list: number[], value: number): number[] {
  const set = new Set(list)
  if (set.has(value)) set.delete(value)
  else set.add(value)
  return Array.from(set).sort((a, b) => a - b)
}
